import { motion } from "framer-motion";

// Circular gold medallion framing an instrument image (white-bg jpeg blends in).
export const InstrumentMedallion = ({ src, label, size = 96, className = "" }) => (
  <div
    className={`relative flex items-center justify-center rounded-full bg-white shadow-[0_10px_30px_-10px_rgba(128,0,0,0.35)] ${className}`}
    style={{
      width: size,
      height: size,
      border: "2px solid var(--gold)",
      outline: "1px solid rgba(212,175,55,0.4)",
      outlineOffset: 4,
    }}
    aria-label={label}
    title={label}
  >
    <img
      src={src}
      alt={label}
      className="h-[78%] w-[78%] object-contain"
      draggable={false}
    />
  </div>
);

// Slowly floating decorative instrument used at section edges.
export const FloatingInstrument = ({ src, label, size, className = "", delay = 0, rotate = 0 }) => (
  <motion.div
    className={`pointer-events-none absolute ${className}`}
    initial={{ opacity: 0, scale: 0.8 }}
    whileInView={{ opacity: 1, scale: 1 }}
    viewport={{ once: true }}
    transition={{ duration: 0.8, delay }}
  >
    <motion.div
      animate={{ y: [0, -14, 0], rotate: [rotate, rotate + 3, rotate] }}
      transition={{ duration: 6, repeat: Infinity, ease: "easeInOut", delay }}
    >
      <InstrumentMedallion src={src} label={label} size={size} />
    </motion.div>
  </motion.div>
);

// Small gold divider with a diamond, echoing temple ornamentation.
export const GoldDivider = ({ className = "" }) => (
  <div className={`flex items-center justify-center gap-4 ${className}`}>
    <span className="h-px w-16 bg-gradient-to-r from-transparent to-[var(--gold)]" />
    <span className="text-[var(--gold)] text-xl">✦</span>
    <span className="h-px w-16 bg-gradient-to-l from-transparent to-[var(--gold)]" />
  </div>
);
